import { Routes } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { UploadDocComponent } from './upload-doc/upload-doc.component';
import { ViewDetailsComponent } from './view-details/view-details.component';
import { MappingResultComponent } from './mapping-result/mapping-result.component';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { AdminComponent } from './admin/admin.component';
import { LogoutComponent } from './_common/logout/logout.component';
import { ViewDocsComponent } from './view-docs/view-docs.component';
import { InstructionDetailsComponent } from './borrower-details/instruction-details/instruction-details.component';

export const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'view-details',
    component: ViewDetailsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'view-docs/:doc_run_id/:quarter/:year',
    component: ViewDocsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'mapping-result',
    component: MappingResultComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'uploadDoc',
    component: UploadDocComponent,
    canActivate: [MsalGuard],
  },
  //{
 //   path: 'ruleEngine',
 //   component: AdminComponent,
 //   canActivate: [MsalGuard],
  //},
  {
    path: 'instructiondetails',
    component: InstructionDetailsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
